import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {AuthService} from '../../core/security/auth.service';
import {Subscription} from 'rxjs';
import {HeaderService} from '../../core/services/header.service';
import {MenuModel} from '../../core/models/menu.model';
import { NavigationEnd, Router, RouterLinkActive, RouterLink } from '@angular/router';
import { MatNavList } from '@angular/material/list';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { MatIconAnchor } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatBadge } from '@angular/material/badge';

@Component({
    selector: 'app-main-nav',
    templateUrl: './main-nav.component.html',
    styleUrls: ['./main-nav.component.scss'],
    standalone: true,
    imports: [MatNavList, NgClass, MatIconAnchor, MatIcon, NgFor, RouterLinkActive, RouterLink, MatTooltip, NgIf, MatBadge]
})
export class MainNavComponent implements OnInit, OnDestroy {

  @Output() public sidenavToggle = new EventEmitter();

  public menuItems = <MenuModel[]>[];

  private currentMenuGroupSubscription: Subscription;
  private routerSubscription: Subscription;
  mobileViewSubscription: Subscription;
  isMobileView = false;

  constructor(private authService: AuthService, public headerService: HeaderService, private router: Router) {

  }

  ngOnInit() {

    console.log('init main navi');

    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.initMenu();
      }
    });

    this.mobileViewSubscription = this.headerService.isMobileView
      .subscribe((value) => {
        this.isMobileView = value;
      });

    this.initMenu();
    // this.updateSize();
  }

  public onToggleSidenav() {
    this.sidenavToggle.emit();
  }

  ngOnDestroy(): void {
    if (this.currentMenuGroupSubscription) {
      this.currentMenuGroupSubscription?.unsubscribe();
    }
    if (this.routerSubscription) {
      this.routerSubscription?.unsubscribe();
    }
  }

  initMenu() {
    this.menuItems = this.headerService.getUserSideMenu();

    for (const menuItem of this.menuItems) {
      this.isCurrentRoute(menuItem);
    }
  }

  public isCurrentRoute(item: MenuModel): boolean {
    let isCurrent = this.router.url.startsWith(item.url);
    item.isCurrent = false;
    if (item.subItems && item.subItems.length > 1) {
      isCurrent = !!item.subItems.find(x => this.router.url.startsWith(x.url));
      item.isCurrent = isCurrent;
      if (isCurrent) {
        item.toggle = isCurrent;
      }
    }

    return isCurrent;
  }

  public toggleSubMenu(item: MenuModel, event: any): void {
    item.toggle = !item.toggle;
    event.preventDefault();
  }

  colorToggle($event: void) {
    this.headerService.toggleColorSchema();
  }

  getTooltipText(menuItem: MenuModel): string {
    if(menuItem.description) {
      return `${menuItem.title} - ${menuItem.description}`
    }

    return menuItem.title;
  }
}
